import { useState } from "react"
import { Helmet } from "react-helmet"

export type FaqItem = {
  question: string
  answer: string
}

type FaqAccordionProps = {
  faqs: FaqItem[]
  title?: string
}

export default function FaqAccordion({
  faqs,
  title = "Frequently Asked Questions",
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const toggle = (index: number) => {
    setOpenIndex(current => (current === index ? null : index))
  }

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(item => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer,
              },
            })),
          })}
        </script>
      </Helmet>
      <section className="bg-[#fff7f4] py-16 px-4 md:px-0">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-center text-2xl md:text-3xl font-bold text-[#222222] mb-10">
            {title}
          </h2>

          <div className="space-y-4">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index

              return (
                <div
                  key={item.question}
                  className="rounded-2xl bg-[#ffe7dd] shadow-sm"
                >
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left"
                  >
                    <span className="font-semibold text-[15px] md:text-base text-[#2a2530]">
                      {item.question}
                    </span>
                    <span className="h-4 w-4 p-2 ml-4 flex items-center justify-center rounded-full bg-white text-sm font-bold text-[#51414b]">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>

                  <div
                    className={`
    grid transition-all duration-300 ease-in-out
    ${isOpen ? "grid-rows-[1fr] opacity-100 py-2" : "grid-rows-[0fr] opacity-0"}
    border-t border-[#f4cfc1]
  `}
                  >
                    <div className="overflow-hidden px-5  text-sm md:text-[15px] text-[#4d4048]">
                      {item.answer}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    </>
  )
}
